// ============================================================
// Die Schale um jeden angemeldeten Bildschirm (Muster lilasprojekte Shell.tsx):
//   1. die schwebende Kopfleiste,
//   2. den Freiraum darunter und über der Reiterleiste (`.schale`),
//   3. die Reiterleiste selbst (blendet sich am Schreibtisch aus),
//   4. die Leiste „Live-Verbindung unterbrochen", wenn ein Bildschirm sie meldet.
//
// Der INHALT bringt seine eigene Breite mit (`.blatt`), `.schale` setzt nur den
// vertikalen Abstand. Der Editor nimmt die volle Breite und legt die Unterleiste mit
// dem Projektnamen selbst darunter (§13.2).
// ============================================================
import { Outlet } from "react-router-dom";
import { LiveLeiste } from "./LiveLeiste";
import { MobilLeiste } from "./MobilLeiste";
import { TopNav } from "./TopNav";

export function Shell() {
  return (
    <>
      {/* Grund in den Lücken um die schwebenden Leisten (app.css `.schale-grund`, §19.17-8). */}
      <div className="schale-grund oben" aria-hidden />
      <div className="schale-grund unten" aria-hidden />
      <TopNav />
      <div className="schale">
        <Outlet />
      </div>
      <MobilLeiste />
      <LiveLeiste />
    </>
  );
}
